/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EnforcementStateEnum } from './enforcementStateEnum';
import { ComponentConfigEnforcementTypeSpec } from './componentConfigEnforcementTypeSpec';


export interface ComponentConfigEnforcementSpec { 
    state: EnforcementStateEnum;
    state_entered_timestamp: Date;
    config?: ComponentConfigEnforcementTypeSpec;
}
export namespace ComponentConfigEnforcementSpec {
}


